import { DeliveryFile } from "models/DeliveryFile";

export type SortDeliveryUploadFile = (
  a: DeliveryFile,
  b: DeliveryFile
) => number;

export function SortByDate(a: DeliveryFile, b: DeliveryFile) {
  return a && b && a.createdAt > b.createdAt ? -1 : 1;
}

export function SortByName(a: DeliveryFile, b: DeliveryFile) {
  return a && b && a.name > b.name ? -1 : 1;
}

export function SortByComment(a: DeliveryFile, b: DeliveryFile) {
  return a && b && a.comment > b.comment ? -1 : 1;
}

export function SortByCreatedBy(a: DeliveryFile, b: DeliveryFile) {
  return a &&
    b &&
    a.createdByName &&
    b.createdByName &&
    a.createdByName > b.createdByName
    ? -1
    : 1;
}

export function SortByCategory(a: DeliveryFile, b: DeliveryFile) {
  return a && b && a.category > b.category ? -1 : 1;
}

export function SortBySize(a: DeliveryFile, b: DeliveryFile) {
  return a && b && a.fileSize > b.fileSize ? -1 : 1;
}
